import sendAnalyticsEvent from '../modules/sendAnalyticsEvent';

export default function(type: string) {
    switch (type) {
        case 'linkedin':
            sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on LinkedIn');
            break;
        case 'twitter':
            sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Twitter');
            break;
        case 'facebook':
            sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Facebook');
            break;
        case 'whatsapp':
            sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on WhatsApp');
            break;
        case 'email':
            sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Email');
            break;
        case 'messenger':
            sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Messenger');
            break;
        default:
    }
};
